import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from './useAuth';
import { AuthPaths } from './AuthConfig';

/**
 * Login component - redirects to Razor Pages login.
 * This is called when user explicitly clicks login or needs to authenticate.
 */
export const Login: React.FC = () => {
  const { isAuthenticated, login } = useAuth();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Already authenticated - redirect to return URL
    if (isAuthenticated) {
      const returnUrl = searchParams.get('returnUrl') || AuthPaths.DefaultRedirect;
      navigate(returnUrl, { replace: true });
      return;
    }

    // Not authenticated - redirect to Razor Pages login
    const returnUrl = searchParams.get('returnUrl') || AuthPaths.DefaultRedirect;
    login(returnUrl);
  }, [isAuthenticated, searchParams, navigate, login]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
      <CircularProgress />
    </Box>
  );
};

/**
 * Logout component - performs logout via Razor Pages.
 */
export const Logout: React.FC = () => {
  const { logout, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      logout();
    } else {
      // Already logged out, redirect to home
      window.location.href = '/';
    }
  }, [isAuthenticated, logout]);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
      <CircularProgress />
    </Box>
  );
};

// Legacy exports for compatibility - these are no longer needed but kept for router config
export const LoginCallback = Login;
export const LogoutCallback = Logout;
